import { render, staticRenderFns } from "./newProductPreSale.vue?vue&type=template&id=65048e07&scoped=true&"
import script from "./newProductPreSale.vue?vue&type=script&lang=js&"
export * from "./newProductPreSale.vue?vue&type=script&lang=js&"
import style0 from "./newProductPreSale.vue?vue&type=style&index=0&id=65048e07&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65048e07",
  null
  
)

export default component.exports